module.exports = __webpack_public_path__ + "img/attendee.9e749852.png";